exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".template-btn[data-v-7c688b22]{color:#0080da;font-size:16px;align-self:center;cursor:pointer}.template-btn[data-v-7c688b22]:hover{text-decoration:underline}", ""]);

// exports
